
import { baseApi } from "../baseApi";

export const deliveryNoteApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		createDeliveryNotePicklist: builder.mutation({
			query: (pickListId) => ({
				url: `/api/method/stackerbee_mobile_wms.wms.api.create_delivery_note_picklist`,
				method: "POST",
				body: { pick_list_id: pickListId },
			}),
			invalidatesTags: ["packing"],
		}),
		getDeliveryNoteDoc: builder.query({
			query: (name) =>({
					url:`/api/method/frappe.desk.form.load.getdoc?doctype=Delivery Note&name=${name}`
				}),
			keepUnusedDataFor: 0,
            providesTags: [],
		}),
		submitDeliveryNote: builder.mutation({
			query: (deliveryNoteId) => ({
				url: `/api/method/stackerbee_mobile_wms.wms.api.submit_delivery_note`,
				method: "POST",
				body: { delivery_note_id: deliveryNoteId },
			}),
		}),
		GetDeliveryNote: builder.mutation({
			query: (payload) => ({
				url: `/api/method/stackerbee_mobile_wms.wms.react_api.get_delivery_note_list`,
				method: "POST",
				body: payload,
			}),
		}),
		getDeliveryNoteIDList: builder.mutation({
			query: () => {
				const formData = new FormData();

				// Append simple fields
				formData.append("doctype", "Delivery Note");
				formData.append("order_by", "modified desc");
				formData.append("view", "List");
				formData.append("start", "0");
				formData.append("page_length", "0");

				const fields = ["name"];
				const filters = [
					["Delivery Note", "status", "=", "To Bill"],
					["Delivery Note", "return_against", "is", "not set"],
				];

				formData.append("fields", JSON.stringify(fields));
				formData.append("filters", JSON.stringify(filters));

				return {
					url: "/api/method/frappe.desk.reportview.get", // adjust endpoint
					method: "POST",
					body: formData,
					// ⚠️ Do NOT set Content-Type header — let browser set it automatically
				};
			},
		}),
	}),
});

export const { 
    useCreateDeliveryNotePicklistMutation,
  useGetDeliveryNoteDocQuery,
  useSubmitDeliveryNoteMutation,
  useGetDeliveryNoteMutation,
  useLazyGetDeliveryNoteDocQuery,useGetDeliveryNoteIDListMutation
 } = deliveryNoteApi;
